var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('el-timeline',_vm._l((_vm.dataList),function(item,index){return _c('el-timeline-item',{key:index,attrs:{"timestamp":item.created_at,"placement":"top"}},[_vm._v(" "+_vm._s(item.ding_dpt ? item.ding_dpt.name : '')+" ")])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }